import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { OrderService } from "@services/order-list/order";
import { DateTimeFormat } from "@utils/date-time-format";
import { JapaneseLabels } from "@utils/japaneseLabels";
import { OrderRecordsSearcQueryResponseInfo, OrderRecordUpdateRequest } from "app/models/order-records.model";


/**
 * XRayList component.
 * Handles the display and logic for listing X-ray entries.
 */
@Component({
  selector: "app-x-ray-list",
  imports: [CommonModule, RouterModule, FormsModule, DateTimeFormat],
  templateUrl: "./x-ray-list.html",
  styleUrl: "./x-ray-list.scss",
  providers: [OrderService]
})
export class XRayList {
  constructor(private orderService: OrderService) { }

  /** japan  text labels */
  japaneseLabel = JapaneseLabels;

  /**
   * Angular lifecycle hook.
   * Fetches the initial order list on component initialization.
   */
  ngOnInit() {
    this.doList();
  }

  /** Current page number (for pagination) */
  page: number = 1;

  /** Number of items per page */
  limit: number = 10;

  /** List of orders for the current page */
  orderList: OrderRecordsSearcQueryResponseInfo[] = [];

  /** Total number of orders */
  totalCount: number = 0;

  /** Total number of pages */
  totalPages: number = 0;

  /** Currently selected page */
  currentPage: number = 1;
  /** Loading state for data fetching */
  loading: boolean = false;
  searchField !: string;
  /**
   * Fetches the orde list for the current page and limit.
   * Updates orderList, totalCount, and totalPages.
   */
  doList() {
    this.loading = true;
    this.orderService.getOrderList(this.currentPage, this.limit, this.searchField).subscribe({
      next: (response) => {
        this.orderList = response.order_records
        this.totalCount = response.total_count;
        this.totalPages = Math.ceil(this.totalCount / this.limit);
      },
      error: (err) => {
        console.error("Error", err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  /**
   * Calculates the start index of the current page.
   * 
   * @returns The starting index (1-based)
   */
  get startIndex(): number {
    return (this.currentPage - 1) * this.limit + 1;
  }

  /**
   * Calculates the end index of the current page.
   * 
   * @returns The ending index (1-based)
   */
  get endIndex(): number {
    return Math.min(this.currentPage * this.limit, this.totalCount);
  }

  /**
   * Generates an array of page numbers for pagination controls.
   * 
   * @returns Array of page numbers
   */
  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  /**
   * Navigates to a specific page if within valid range.
   * 
   * @param page The page number to navigate to
   */
  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.doList();
    }
  }

  // /**
  //  * Navigates to the previous page if not on the first page.
  //  */
  // previousPage() {
  //   if (this.currentPage > 1) {
  //     this.currentPage--;
  //     this.doList();
  //   }
  // }

  /**
   * Navigates to the next page if not on the last page.
   */
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.doList();
    }
  }

  /**
   * Handles changes to the items-per-page limit.
   * Resets to the first page and fetches new data.
   * 
   * @param event The change event from the limit select element
   */
  onLimitChange(event: Event) {
    const value: string = (event.target as HTMLSelectElement).value;
    this.limit = +value; // convert to number
    this.currentPage = 1; // reset to first page
    this.doList();
  }

  /**
   * Handle changes to the search input field.
   * Resets pagination to the first page and reloads the order list whenever the search term changes. *
   *
   */
  onSearchFieldChange() {
    if (this.searchField) {
      this.currentPage = 1; // reset to first page
      this.doList();
    } else {
      // alert("検索キーワードを入力してください。");
      // this.searchField = "";
      this.currentPage = 1; // reset to first page
      this.doList();
    }
  }
  serial_no?: number;
  /**
   * Handles changes to the select update api call.
   * Resets to the first page and fetches new data.
   * 
   * @param order The order get data select element
   * @param event The change event from the limit select element
   */
  updateStatus(order: OrderRecordsSearcQueryResponseInfo, event: Event): void {

    const selectedValue: string = (event.target as HTMLSelectElement).value;

    let newStatus: boolean;

    if (selectedValue === 'toggle') {
      newStatus = !order.is_valid; // Toggle status
    } else {
      newStatus = (selectedValue === 'true'); // Keep same if user picks 有効/無効 explicitly
    }

    const payload: OrderRecordUpdateRequest = {
      order_record_id: order.order_record_id,
      is_valid: newStatus
    };
    this.serial_no = order.serial_no
    this.orderService.orderUpdate(payload).subscribe({
      next: (response) => {
        console.log('API Response:', response);
        order.is_valid = newStatus; // Update UI after success
        alert(`申請番号 ${this.serial_no} のレントゲンファイルのステータスが「有効」に変更されました。`);
        this.doList();
      },
      error: (err) => {
        console.error('API Error:', err);
      }
    });
  }

}